module.exports = __webpack_public_path__ + "img/collage-img.bbb65949.png";